;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Model = APP.module('Model');

	var getWidgets = function () {
		if (getUserAge() >= 18) {
			return ['MenuSideBar', 'Promo'];
		} else {
			return ['MenuSideBar'];
		}
	};
	var getUserAge = function () {
		var user = localStorage.getItem('User');
		if (user === null) {
			return 0;
		}
		var user_number = user.split(',').slice(-1)[0].trim();
		var user_object = JSON.parse(localStorage.getItem('User-' + user_number));

		var today = new Date();
		var birthDate = new Date(user_object.birthday);
		var age = today.getFullYear() - birthDate.getFullYear();
		var m = today.getMonth() - birthDate.getMonth();
		if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
			age--;
		}
		return age;
	};

	Model.SidebarBuilder = Model.SidebarBuilder.extend({
		defaults: {
			widgets: getWidgets(),
			menuItems: [
				{ name: 'Tipping Game Guidelines', url: 'help/game-guidelines', status: ''},
				{ name: 'Tipping FAQs', url: 'help/faqs', status: ''},
				{ name: 'Terms and Conditions', url: 'help/terms', status: ''},
				{ name: 'Prizes', url: 'help/prizes', status: ''},
				{ name: 'Contact Us', url: 'help/contact-us', status: ''}
			]
		},

		setMenuItems: function() {
			var route_name = CONFIG.OFF_SEASON ? 'off-season/' : '',
				menu_items = [
					{ name: 'Tipping Game Guidelines', url: route_name + 'help/game-guidelines', status: ''},
					{ name: 'Tipping FAQs', url: route_name + 'help/faqs', status: ''},
					{ name: 'Terms and Conditions', url: route_name + 'help/terms', status: ''},
					{ name: 'Prizes', url: route_name + 'help/prizes', status: ''},
					{ name: 'Contact Us', url: route_name + 'help/contact-us', status: ''}
				];

			if (CONFIG.OFF_SEASON) {
				menu_items.pop();
			}

			if (CONFIG.OFF_SEASON) {
				this.set('menuItems', menu_items);
			}

			return this;
		},

		initialize: function(){
			this.setMenuItems()
				.setActiveState();
			APP.help_started = false;
		}
	});

}(window, APP, Backbone, Marionette, $, _));